function normalizeRawValue(value) {
  const normalized = String(value || '').trim();
  return normalized || null;
}

function ensureHttps(url) {
  if (!url) return null;
  if (/^https?:\/\//i.test(url)) {
    return url;
  }
  return `https://${url}`;
}

function cleanupHandle(value) {
  return value.replace(/^@+/, '').replace(/^https?:\/\/(www\.)?/i, '').replace(/^t\.me\//i, '').replace(/^telegram\.me\//i, '').replace(/^vk\.com\//i, '').replace(/^max\.ru\//i, '').replace(/^\/+/, '').trim();
}

export function normalizeTelegramValue(value) {
  const raw = normalizeRawValue(value);
  if (!raw) return null;
  if (/^https?:\/\//i.test(raw)) {
    return raw;
  }
  const handle = cleanupHandle(raw);
  return handle ? `https://t.me/${handle}` : null;
}

export function normalizeVkValue(value) {
  const raw = normalizeRawValue(value);
  if (!raw) return null;
  if (/^https?:\/\//i.test(raw)) {
    return raw;
  }
  const handle = cleanupHandle(raw);
  return handle ? `https://vk.com/${handle}` : null;
}

export function normalizeMaxValue(value) {
  const raw = normalizeRawValue(value);
  if (!raw) return null;
  if (/^https?:\/\//i.test(raw)) {
    return raw;
  }
  if (/^(web\.)?max\.ru\//i.test(raw)) {
    return `https://${raw}`;
  }
  return raw;
}

export function normalizeWebsiteValue(value) {
  const raw = normalizeRawValue(value);
  if (!raw) return null;
  return ensureHttps(raw);
}

export function normalizeContactValue(kind, value) {
  if (kind === 'telegram') return normalizeTelegramValue(value);
  if (kind === 'vk') return normalizeVkValue(value);
  if (kind === 'max') return normalizeMaxValue(value);
  if (kind === 'website') return normalizeWebsiteValue(value);
  if (kind === 'email') return normalizeRawValue(value);
  return normalizeRawValue(value);
}

export function buildContactLink(kind, value) {
  const normalized = normalizeContactValue(kind, value);
  if (!normalized) return null;
  if (kind === 'email') {
    return {
      href: `mailto:${normalized}`,
      label: normalized,
    };
  }
  if (kind === 'max') {
    if (!/^https?:\/\//i.test(normalized)) {
      return null;
    }
    return {
      href: normalized,
      label: normalized,
    };
  }
  return {
    href: normalized,
    label: normalized,
  };
}
